import React from "react";
import "../../styles/Account.css";

export interface AccountNavProps {
  email: string,
  firstName: string,
  lastName: string,
  logout: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const AccountNav = (props: AccountNavProps) => {
  return (
    <nav className={"AccountDropdown"}>
      <ul>
        <li className={"AccountInfo AccountItem"}>
          <div className={"AccountUser"}>{props.firstName} {props.lastName}</div>
          <div className={"AccountEmail"}>{props.email}</div>
        </li>
        <li>
          <a className={"AccountItem AccountNavLink"} target="_blank" href="https://success.vitalsource.com/hc/en-us/categories/23251248756503-Studio">Support</a>
        </li>
        <li>
          <button className={"AccountNavButton AccountItem"} onClick={props.logout}>Sign Out</button>
        </li>
      </ul>
    </nav>
  )
}

export default AccountNav;
